import React, {useState} from 'react';
import {MainService} from "../../_services";
import { useScanDetection } from "../../_hooks";

function Scanner(props)  {
  const [data, setData] = useState([]);
  const [notFound, setNotFound] = useState([]);
  const ms = new MainService();
  const [value, setValue] = useState('');
  useScanDetection({
    onComplete: (code) => {
      setValue(code);
      addItem(code)
    },
  });
  const addItem = (item, isManualyAdded = false) => {
    console.log(item);

    // Validation du numéro de série
    const validationResult = validateSerialNumber(item);

    if (validationResult.isValid) {
      searchProduct(item, isManualyAdded);
    } else {
      // Message d'erreur et gestion de la 2ème chance
      handleValidationError(validationResult.error, item);
    }
  };

  const validateSerialNumber = (serial) => {
    if (!serial || typeof serial !== 'string') {
      return { isValid: false, error: 'Numéro de série invalide' };
    }

    const length = serial.length;
    const first3Chars = serial.substring(0, 3).toUpperCase();
    const chars5And6 = serial.substring(4, 6); // Index 4-5 pour les 5ème et 6ème caractères

    // Condition 1 : SET ou DME => 15 caractères
    if (first3Chars === 'SET' || first3Chars === 'DME') {
      if (length === 15) {
        return { isValid: true };
      }
      return {
        isValid: false,
        error: `Numéro commençant par ${first3Chars} : 15 caractères attendus, ${length} trouvés`
      };
    }

    // Condition 2 : B1 ou B2 en positions 5-6 => 14 caractères
    if (chars5And6 === 'B1' || chars5And6 === 'B2') {
      if (length === 14) {
        return { isValid: true };
      }
      return {
        isValid: false,
        error: `Numéro avec ${chars5And6} en positions 5-6 : 14 caractères attendus, ${length} trouvés`
      };
    }

    // Condition 3 : 80-84 en positions 5-6 => 13 caractères
    const validCodes = ['80', '81', '82', '83', '84'];
    if (validCodes.includes(chars5And6)) {
      if (length === 13) {
        return { isValid: true };
      }
      return {
        isValid: false,
        error: `Numéro avec ${chars5And6} en positions 5-6 : 13 caractères attendus, ${length} trouvés`
      };
    }
    // Si aucune règle ne correspond, vous pouvez soit accepter, soit rejeter
    return {
      isValid: false,
      error: 'Format de numéro de série non reconnu'
    };
  };

  const handleValidationError = (errorMessage, item) => {
    alert(errorMessage);
  };

// Fonction à implémenter selon votre scanner
  const triggerScannerRead = () => {
    // Implémentation dépendante de votre scanner
    console.log('Nouvelle lecture demandée...');
  };

    const isFirstPartSameAsSecond = (str) => {
    const length = str.length;
    const halfLength = Math.floor(length / 2);
    const firstPart = str.substring(0, halfLength);
    const secondPart = str.substring(halfLength, length);
    return firstPart === secondPart ? firstPart : str;
  }
    const searchProduct = (barCode, isMannualyAdded ) => {
      ms.searchProduct(barCode).then((data)=> {
        setNotFound(false);
        props.onScan({...data.data,serialNumber : isFirstPartSameAsSecond(barCode), manualEntry : isMannualyAdded})
      }).catch((err) => {
        setNotFound(true);
        alert('Article non reconnu !')
      })
    }
    return (
      <>
        <p className={"mt_15"}>Scanner ou saisir le numéro de série : </p>
        <div className={"input-1"}>
          <span className={"fa fa-file icon-i"}></span>
          <input type="text"
                 placeholder={"N° de série "}
                 value={value}
                 onChange={e => setValue(e.target.value)}
          />
          <button disabled={!value || props.currentGrid.manualEntry >= 10} onClick={()=> {addItem(value,true)}} className={"btn-send"}><i className={"fa fa-paper-plane"}></i></button>
        </div>
        {
          props.currentGrid.manualEntry >= 10 &&
          <p className={"text-center small-text"}>Impossible de rajouter manuellement des numéros de série à cette grille! (la limite de 10 insertions a été dépassée)</p>
        }
      </>
    )
}

export {Scanner};
